import { ReactComponent as ReloadIcon } from 'assett/icons/reload.svg';
import { ReactComponent as SearchHideIcon } from 'assett/icons/search_hide_icon.svg';
import { ReactComponent as SearchIcon } from 'assett/icons/search_icon.svg';
import SelectGeneric from 'components/commons/form/SelectGeneric';
import HeaderCellWithSorting from 'components/commons/list/HeaderCellWithSorting';
import {
	handleChange,
	resetInputFilters,
	setSearch,
} from 'feature/form/formSlice';
import { setDownloadAll } from 'feature/tableSelectedItems/tableSelectedItemsSlice';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import {
	Box,
	Checkbox,
	DatePicker,
	TableCell,
	TableHead,
	TableRow,
} from 'styles';
import IconButton from 'styles/button/IconButton';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';

const FraudTrackingHeader = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.DB_LABELS,
	});
	const dispatch = useDispatch<AppDispatch>();
	const { downloadAll } = useSelector(
		(store: RootState) => store.tableSelectedItems,
	);
	const {
		search,
		inputDetectionDate,
		inputReferralDate,
		inputInvestigationStatus,
		fraudStatuses,
	} = useSelector((store: RootState) => store.form);

	return (
		<TableHead>
			<TableRow>
				<TableCell sx={{ width: 44 }}>
					<Checkbox
						label=""
						onClick={() => {
							dispatch(setDownloadAll(!downloadAll));
						}}
						checked={downloadAll}
						sx={{ p: 0 }}
					/>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting name="fraudId" widthBox={235} widthInput={235} />
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="externalClaimId"
						widthBox={235}
						widthInput={235}
					/>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="detectionDate"
						widthBox={235}
						widthInput={235}
					>
						{search && (
							<Box sx={{ width: 235 }}>
								<DatePicker
									variant="field"
									label={tClientLabels('forms.header.detectionDate')}
									value={inputDetectionDate}
									onChange={value =>
										dispatch(handleChange({ name: 'inputDetectionDate', value }))
									}
								/>
							</Box>
						)}
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting
						name="investigationStatus"
						widthBox={235}
						widthInput={235}
					>
						<SelectGeneric
							action={status =>
								dispatch(
									handleChange({
										name: 'inputInvestigationStatus',
										value: status === 'All' ? '' : status,
									}),
								)
							}
							items={[
								{ value: 'All', text: tClientLabels('forms.status.All') },
								...fraudStatuses.map(el => ({
									value: el.code,
									text: tDbLabels(el.label),
								})),
							]}
							name={'investigationStatus'}
							initialValue={inputInvestigationStatus || 'All'}
							sxForm={{ flex: 1, width: '100%' }}
						/>
					</HeaderCellWithSorting>
				</TableCell>
				<TableCell sx={{ width: 235 }}>
					<HeaderCellWithSorting name="referralDate" widthBox={235} widthInput={235}>
						{search && (
							<Box sx={{ width: 235 }}>
								<DatePicker
									variant="field"
									label={tClientLabels('forms.header.referralDate')}
									value={inputReferralDate}
									onChange={value =>
										dispatch(handleChange({ name: 'inputReferralDate', value }))
									}
								/>
							</Box>
						)}
					</HeaderCellWithSorting>
				</TableCell>
				{
					//this is to fill the woid and make the arrow sticky at the end
				}
				<TableCell sx={{ minWidth: 235 + 10 }} />
				{
					//this is for the reload button column
				}
				<TableCell sx={{ minWidth: '56px', textAlign: 'center' }}>
					{search && (
						<IconButton onClick={() => dispatch(resetInputFilters())}>
							<ReloadIcon />
						</IconButton>
					)}
				</TableCell>
				<TableCell>
					<IconButton onClick={() => dispatch(setSearch(!search))}>
						{search ? <SearchHideIcon /> : <SearchIcon />}
					</IconButton>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default FraudTrackingHeader;
